import React from 'react'
import DOMPurify from 'dompurify'
import { Image } from 'src/components/ui/Image'

interface InsuranceBenefitSteps {
  icon: string
  text: string
}

interface InsuranceSectionBenefitStepProps {
  items: InsuranceBenefitSteps[]
}

const InsuranceSectionBenefitStep: React.FC<
  InsuranceSectionBenefitStepProps
> = ({ items }) => (
  <section className="w-full max-w-[1280px] mt-6 mb-6 md:mt-16 md:mb-28 mx-auto px-4 flex md:justify-between justify-center flex-wrap gap-4 md:gap-0 ">
    {items.map((item, idx) => (
      <div
        key={idx}
        className="bg-white border border-[#E5E5E5] py-6 px-7 flex flex-col gap-3 w-full max-w-[400px] min-w-[260px]"
      >
        <div className="w-9 h-11 flex items-center justify-center mb-2">
          <Image
            src={item.icon}
            alt={`Etapa ${idx + 1}`}
            className="w-9 h-11"
          />
        </div>
        <p
          className="text-[#101010] text-base font-semibold leading-snug [&_a]:underline [&_a]:font-semibold"
          dangerouslySetInnerHTML={{
            __html:
              typeof DOMPurify?.sanitize === 'function'
                ? DOMPurify.sanitize(item.text)
                : item.text,
          }}
        />
      </div>
    ))}
  </section>
)

export default InsuranceSectionBenefitStep
